/**
 * We could instead return a FEWSURL
 * but we may want to change them once returned
 * in some special cases
 * This isn't really a class, it is really a hash table that takes two parameters;
 * the request type and the locationID and returns an object
 * TODO: Replace with FEWSURL directly
 * */
export class RequestConfigBuilder {
    constructor() {
        this.baseConfig = {
            startDateNumDaysPrevious: 7,
            endDateNumDaysInFuture: 5,
            forecast: true,
        };
    }
    /**
     * Builds request with ImportTelemetry (ModuleInstanceId) and Q.obs (ParameterId)
     * @param locationID location we want this timeseries for
     */
    buildObservedFlowRequest(locationID) {
        return Object.assign(Object.assign({}, this.baseConfig), { moduleInstanceID: "ImportTelemetry", parameterIds: "Q.obs", locationIds: locationID });
    }
    /**
    * Builds request with ImportTelemetry (ModuleInstanceId) and Q.rated (ParameterId)
    * @param locationID location we want this timeseries for
    */
    buildObservedRatedFlowRequest(locationID) {
        return Object.assign(Object.assign({}, this.baseConfig), { moduleInstanceID: "ImportTelemetry", parameterIds: "Q.rated", locationIds: locationID });
    }
    /**
    * Builds request with PDM_Lee_ARMA_Historical (ModuleInstanceId) and Q.updated.historical (ParameterId)
    *
    * @param locationID
    */
    buildHistoricalFlowRequest(locationID) {
        console.log('Hist ' + locationID);
        if (locationID == "19103") {
            console.log('Hist1 ' + locationID);
            return Object.assign(Object.assign({}, this.baseConfig), { moduleInstanceID: "ISIS_Bride_ARMA_Historical", parameterIds: "Q.updated.historical", locationIds: locationID });
        }
        else {
            console.log('Hist2 ' + locationID);
            return Object.assign(Object.assign({}, this.baseConfig), { moduleInstanceID: "PDM_Lee_ARMA_Historical", parameterIds: "Q.updated.historical", locationIds: locationID });
        }
    }
    /**
    * Builds request with PDM_Lee_ARMA_Forecast (ModuleInstanceId) and Q.updated.forecast (ParameterId)
    * @param locationID location we want this timeseries for
    */
    buildforecastFlowRequest(locationID) {
        if (locationID == "19103") {
            return Object.assign(Object.assign({}, this.baseConfig), { moduleInstanceID: "ISIS_Bride_ARMA_Forecast", parameterIds: "Q.updated.forecast", locationIds: locationID });
        }
        else {
            return Object.assign(Object.assign({}, this.baseConfig), { moduleInstanceID: "PDM_Lee_ARMA_Forecast", parameterIds: "Q.updated.forecast", locationIds: locationID });
        }
    }
    /**
    * Builds request with ISIS_Lee_Forecast (ModuleInstanceId) and Q.simulated.forecast (ParameterId)
    * If we're looking at a particular location (19102) then we use a slightly different module instance id of "ISIS_Lee_Cork_Forecast"
    * @param locationID location we want this timeseries for
    */
    buildSimulatedFlowForecastRequest(locationID) {
        if (locationID == "19102") {
            return Object.assign(Object.assign({}, this.baseConfig), { moduleInstanceID: "ISIS_Lee_Cork_Forecast", parameterIds: "Q.simulated.forecast", locationIds: locationID });
        }
        else {
            return Object.assign(Object.assign({}, this.baseConfig), { moduleInstanceID: "ISIS_Lee_Forecast", parameterIds: "Q.simulated.forecast", locationIds: locationID });
        }
    }
    /**
    * Builds request with ISIS_Lee_Forecast (ModuleInstanceId) and Q.simulated.historical (ParameterId)
    * @param locationID location we want this timeseries for
    */
    buildSimulatedFlowHistoricalRequest(locationID) {
        return Object.assign(Object.assign({}, this.baseConfig), { moduleInstanceID: "ISIS_Lee_Forecast", parameterIds: "Q.simulated.historical", locationIds: locationID });
    }
    /**
    * Builds request with ISIS_Lee_Historical (ModuleInstanceId) and Q.simulated.historical (ParameterId)
    * If we're looking at a particular location (19102) then we use a slightly different module instance id of "ISIS_Lee_Cork_Historical"
    * @param locationID location we want this timeseries for
    */
    buildSimulatedISISFlowHistoricalRequest(locationID) {
        if (locationID == "19102") {
            return Object.assign(Object.assign({}, this.baseConfig), { moduleInstanceID: "ISIS_Lee_Cork_Historical", parameterIds: "Q.simulated.historical", locationIds: locationID });
        }
        else {
            return Object.assign(Object.assign({}, this.baseConfig), { moduleInstanceID: "ISIS_Lee_Historical", parameterIds: "Q.simulated.historical", locationIds: locationID });
        }
    }
    /**
    * Builds request with ImportTelemetry (ISIS_Lee_Historical) and H.simulated.historical (ParameterId)
    * @param locationID location we want this timeseries for
    */
    buildSimulatedISISLevelHistoricalRequest(locationID) {
        return Object.assign(Object.assign({}, this.baseConfig), { moduleInstanceID: "ISIS_Lee_Historical", parameterIds: "H.simulated.historical", locationIds: locationID });
    }
    /**
    * Builds request with ISIS_Lee_Cork_Forecast (ModuleInstanceId) and H.simulated.forecast (ParameterId)
    * @param locationID location we want this timeseries for
    */
    buildSimulatedLevelForecastRequest(locationID) {
        return Object.assign(Object.assign({}, this.baseConfig), { moduleInstanceID: "ISIS_Lee_Forecast", parameterIds: "H.simulated.forecast", locationIds: locationID });
    }
    /**
    * Builds request with Lee_Releases_48hr_Forecast (ModuleInstanceId) and Q.release (ParameterId)
    * @param locationID location we want this timeseries for
    */
    buildForecastRelease48HrRequest(locationID) {
        return Object.assign(Object.assign({}, this.baseConfig), { moduleInstanceID: "Lee_Releases_48hr_PostProcess_Forecast", parameterIds: "Q.release", locationIds: locationID });
    }
    /**
    * Lee_Releases_Forecast Q.Release
    * Builds request with Lee_Releases_Forecast (ModuleInstanceId) and W.release (ParameterId)
    * @param locationID location we want this timeseries for
    */
    buildForecastReleaseRequest(locationID) {
        return Object.assign(Object.assign({}, this.baseConfig), { moduleInstanceID: "Lee_Releases_PostProcess_Forecast", parameterIds: "Q.release", locationIds: locationID });
    }
    /**
    * Builds request with ImportTelemetry (ModuleInstanceId) and H.obs (ParameterId)
    * @param locationID location we want this timeseries for
    */
    buildObservedWaterLevelRequest(locationID) {
        return Object.assign(Object.assign({}, this.baseConfig), { moduleInstanceID: "ImportTelemetry", parameterIds: "H.obs", convertDatum: "TRUE", locationIds: locationID });
    }
    buildEmpty(locationID) {
        return Object.assign(Object.assign({}, this.baseConfig), { moduleInstanceID: "", parameterIds: "", locationIds: locationID });
    }
    /**
    * Builds request with MergedPrecipitation_Forecast (ModuleInstanceId) and p.merged (ParameterId)
    * @param locationID
    */
    buildMergedPrecipitationForecastRequest(locationID) {
        return Object.assign(Object.assign({}, this.baseConfig), { moduleInstanceID: "MergedPrecipitation_Forecast", parameterIds: "P.merged", locationIds: locationID });
    }
    /**
* Builds request with Disaggregate_ME_PTotal (ModuleInstanceId) and P.me.forecast (ParameterId)
* @param locationID location we want this timeseries for
*/
    buildMERainDeterministicRequest(locationID) {
        return Object.assign(Object.assign({}, this.baseConfig), { moduleInstanceID: "Disaggregate_ME_PTotal", parameterIds: "P.me.forecast", locationIds: locationID });
    }
    /**
* Builds request with Disaggregate_ECMWF_PTotal (ModuleInstanceId) and P.ecmwf.forecast (ParameterId)
* @param locationID location we want this timeseries for
*/
    buildECMWFRainDeterministicRequest(locationID) {
        return Object.assign(Object.assign({}, this.baseConfig), { moduleInstanceID: "Disaggregate_ECMWF_PTotal", parameterIds: "P.ecmwf.forecast", locationIds: locationID });
    }
    /**
    *
    * @param locationID
    * @param moduleInstanceID
    * @param parameterID
    * @param summarySeries
    */
    buildRequestConfig(locationID, moduleInstanceID, parameterID, summarySeries, convertDatum) {
        return Object.assign(Object.assign({}, this.baseConfig), { moduleInstanceID: moduleInstanceID, parameterIds: parameterID, locationIds: locationID, summarySeries: summarySeries, convertDatum: convertDatum });
    }
    buildCumulativeDataset(data) {
        // Data is an array of objects of {x:value, y:value}
        // Assumes array is already sorted by x values in each object
        // Sort data by first object key
        //let sortedData = sortObject(data, undefined, undefined, undefined, undefined, true);
        data.sort(function (a, b) {
            var keyA = new Date(a.updated_at), keyB = new Date(b.updated_at);
            // Compare the 2 dates
            if (keyA < keyB)
                return -1;
            if (keyA > keyB)
                return 1;
            return 0;
        });
        var cumulativeData = [];
        var runningTotal = 0;
        $.each(data, function (idx, valuesXY) {
            runningTotal += parseFloat(valuesXY.y);
            cumulativeData.push({
                x: valuesXY.x,
                y: runningTotal.toFixed(2),
            });
        });
        return cumulativeData;
    }
}
